/** @module csi/action/DownloadController */
define([
	"dojo/_base/declare",
	"underscore",
	"csi",
	"csi/action/Controller",
	"csi/comm/PostRequest",
	"file-saver",
], function (declare, _, csi, Controller, PostRequest, FileSaver) {

	return declare(Controller, {
		// Boolean: Indicates response will not be cached. Caching is not needed since it is a blob we are downloading. 
		bCacheResponse: false,

		// Boolean: Indicates that wait screen should be displayed while downloading in progress.
		bShowWait: true,

		/**
		 * Extension point to configure request
		 * @param {PostRequest} request
		 */
		onDownloadRequest: function(request) { },

		/**
		 * @override
		 * Validate form before continuing
		 */
		onPreActionDeferreds: function(dfds) {
			dfds.push(this.validate());
		},

		/**
		 * @override
		 * Issue PostRequest to download
		 */
		process: function() {
			var actionRequest = this.m_action.m_request;
			var request = new PostRequest(actionRequest.m_module, actionRequest.m_operation);

			_.each(actionRequest.m_parameters, function(p) {
				request.addParameter(p.m_id, p.m_value);
			});

			// add fields if on form
			var view = this.popupView || this.widget;
			var fields = view.defView.m_fields;

			_.each(fields, function(f) {
				if (f.idParameter) {
					request.addParameter(f.idParameter, f.getValue());
				}
			});
			
			this.onDownloadRequest(request);
			this.waitForPublish(request.post({ handleAs: "blob" }))
		},

		/**
		 * @override
		 * Save blob response as a file, default file name is actionId
		 */
		onPublishResponse(response) {
			FileSaver.saveAs(response.data, this.getRequestActionId());
		},
	});
});